<template>
    <div class="layer">
        <div id="content">
            <div id="title">系统数据说明</div>
            <div class="content">
                <div>
                    <p>1.&nbsp;本系统的数据来源于多年数据实践积累，数据处理大部分通过计算机分析完成，结合小部分人工检查，脱漏在所难免，欢迎大家试用指正；</p>
                    <p>2.&nbsp;系统对于同名同姓的处理原则以机构为单位归并，即同一机构默认同名同姓为一人，迨学者认领后区分；</p>
                    <p>3.&nbsp;系统对于机构名称默认取一级机构，如“浙江大学图书馆”默认为“浙江大学”，用户在搜索学者时请使用一级机构；</p>
                    <p>4.&nbsp;系统对于学者英文姓名采用计算机枚举规则，一般做如下处理：</p>
                    <div class="item">
                        <p>A.&nbsp;姓拼音 名拼音及姓拼音,名拼音；</p>
                        <p>B.&nbsp;姓拼音首字母 名拼音首字母；</p>
                        <p>C.&nbsp;名拼音,姓拼音及名拼音,姓拼音；</p>
                        <p>D.&nbsp;名拼音 姓首字母；</p>
                        <p>E.&nbsp;名拼音首字母，姓拼音首字母。</p>
                    </div>
                    <p>5.&nbsp;上述规则无法穷举，再加上中文多音字的问题，因此在发现SCI、EI索引论文时容易出现错误，请学者自行更正即可；</p>
                    <p>6.&nbsp;成果数据中由于图书元数据基本上没有作者单位的信息，因此同名同姓者的著作往往归于一人，目前也没有更好的处理方式；</p>
                    <p>7.&nbsp;表1.为本系统当前的数据收录情况，有关信息可以下载观览。</p>
                </div>
                <div class="table-content">
                    <div class="title">表1 系统收录数据情况</div>
                    <el-table :data="tableData" :stripe="true"  v-loading="loading"  border style="width: 100%">
                         <el-table-column
                            v-for="(item,index) in cloumns" :key="index"
                            :type="item.type"
                            v-if="index<3"
                            :prop="item.prop"
                            :label="item.label"
                            :width="item.width"
                            :fixed="item.fixed">
                        </el-table-column>
                        <el-table-column label="简介" >
                            <template slot-scope="scope">
                               <span>{{scope.row.discript}}</span><a style="float:right" :href="scope.row.xls">{{scope.row.btn}}</a>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="description">注：统计时间截至<span>{{dateTime}}</span></div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { getAllCountData } from '@/api/claim'
export default {
  name: 'state',
  data () {
    return {
      cloumns: [
        {prop: 'name', label: '资源类型' },
        {prop: 'doc_count', label: '数量（条）'},
        {prop: 'year', label: '收录时间范围' },
        {prop: 'discript', label: '简介'}
      ],
      loading: false,
      dateTime: '',
      tableData: [],
      dataTpl: {
        'J': {
          name: '中文期刊论',
          year: '1915 - ' + new Date().getFullYear(),
          discript: '国内29435种中文期刊的期刊论文元数据。 ',
          xls: 'http://expert.ckcest.cn/file/journal.xls',
          btn: '收录中文期刊名录下载'
        },
        'P': {
          name: '学位论文',
          year: '2002 - 2015',
          discript: '国内博士、硕士研究生论文元数据。'
        },
        'I': {
          name: '项目数据',
          year: '1993 - 2019',
          discript: '国家级、省市级已经结题的项目元数据。'
        },
        'B': {
          name: '成果奖励数据',
          year: '1978 - 2014',
          discript: '科技成果及国家级科技奖励、计划、鉴定项目元数据，涉及自然科学的各个学科领域。'
        },
        'D': {
          name: '专利数据',
          year: '1985 - 2019',
          discript: '1985 - 2019'
        },
        'C': {
          name: 'SCI收录',
          year: '1901 - ' + new Date().getFullYear(),
          discript: '43528种期刊中来自中国机构的SCI收录论文元数据。',
          xls: 'http://expert.ckcest.cn/file/Sci.xlsx',
          btn: '收录SCI名录下载'
        },
        'A': {
          name: 'EI收录',
          year: '1884 - 2019',
          discript: '5114种期刊中来自中国机构的EI收录的论文元数据。  ',
          xls: 'http://expert.ckcest.cn/file/EI.xls',
          btn: '收录EI名录下载'
        },
        'E': {
          name: '会议论文',
          year: '1953 - 2015',
          discript: '中外会议论文元数据。'
        },
        'O': {
          name: '图书',
          year: '1809 - 2016',
          discript: '中文图书元数据。'
        },
        'U': {
          name: '中国专家',
          year: '1915 - ' + new Date().getFullYear(),
          discript: '由中文期刊清洗得到。'
        }

      }
    }
  },
  mounted () {
    this.getAllCountData()
  },
  methods: {

    getAllCountData () {
      this.loading = true
      var that = this
      getAllCountData().then(res => {
        if (res.data) {
          let allcount = res.allcount.data
          let dataTpl = that.dataTpl
          allcount.map((item, i) => {
            if (dataTpl[item.key]) {
              allcount[i] = {
                ...item,
                ...dataTpl[item.key]
              }
            }
          })
          that.tableData = allcount
          that.dateTime = res.resource_before_count.updatetime
          that.loading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
a,a:hover{
    background: 0 0;
    color: #4183C4;
    text-decoration: none;
}
#content{
    background: #ffffff;
    padding: 0.5rem 1rem;
    color: #505961;
}

#title{
    font-size: 1rem;
    line-height: 3rem;
    text-align: center;

    font-weight: 600;
}

#content .content{
    font-size:1rem;
}

#content .content .item{
    margin-left: 1rem;
}

#content p{
    margin: 0;
    line-height: 1.5rem;
}

#content .table-content{
    margin: 1rem 0;
}

#content .table-content .title{
    text-align: center;
    padding: 20px 0;
}

#content table.center{
    text-align: center;
}

#content table .left-align{
    text-align: left;
}

#content .table-content .description{
    margin-top: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/view/state/state.vue